module.exports = __webpack_public_path__ + "static/media/logo111.3eb895d9.png";